<template>
  <b-row>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.svg" />
    </vue-element-loading>
    <b-col cols="12" xl="12">
      <transition name="slide">
        <b-card>
          <template slot="header">
            <b-row>
              <b-col cols="12" md="3" class="py-2">
                <span>Users</span>
              </b-col>
              <b-col cols="12" md="3" class="py-2">
                <b-form>
                  <b-row>
                    <b-col cols="8">
                      <b-input-group size="sm">
                        <b-form-input
                          list="searchData"
                          v-model="searchKey"
                          placeholder="Search"
                          size="sm"
                        ></b-form-input>

                        <b-input-group-append>
                          <b-button
                            :disabled="!searchKey"
                            @click="searchKey = ''"
                            variant="outline-primary"
                            size="sm"
                          >
                            Clear
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-col>
                  </b-row>
                </b-form>
              </b-col>
            </b-row>
          </template>
          <b-table
            :items="users"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :hover="true"
            :striped="true"
            :bordered="false"
            :small="false"
            :fixed="false"
            :filter="searchKey"
            :filter-included-fields="filterOn"
            responsive="sm"
            @row-clicked="rowClicked"
          >
            <template v-slot:cell(name)="data">
              <span>{{ data.item.name.slice(0, 50) }}</span>
              <span v-if="data.item.name.length > 50"> ... </span>
            </template>
            <template v-slot:cell(banned)="data">
              <span v-if="data.item.Banned">Banned</span>
              <span v-else>Active</span>
            </template>
            <template v-slot:cell(_id)="data">
              <b-button
                :disabled="data.item.banned"
                @click="confirmBanUser(data.item)"
                size="sm"
                variant="danger"
              >
                Ban User
              </b-button>
            </template>
          </b-table>
          <nav>
            <b-pagination
              size="sm"
              :total-rows="totalData"
              :per-page="perPage"
              v-model="currentPage"
              prev-text="Prev"
              next-text="Next"
            />
          </nav>
          <template slot="footer">
            <b-button @click="$router.go(-1)" size="sm">Back</b-button>
          </template>
        </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      users: [],
      fields: [
        { key: "name", label: "Name", sortable: true },
        { key: "mobileno", label: "Phone", sortable: false },
        { key: "email", label: "Email", sortable: false },
        { key: "username", label: "Username", sortable: false },
        // { key: "OrdersMade", label: "Orders Made", sortable: true },
        { key: "banned", label: "Status", sortable: true },
        { key: "_id", label: "Action", sortable: false },
      ],

      filter: null,
      filterOn: [],

      totalData: 0,
      currentPage: 1,
      perPage: 50,
      totalRows: 0,
      appLoading: false,
      ServerError: false,
      searchKey: null,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    nextPage(ev) {
      this.currentPage = ev;
      this.getCategory();
    },

    getData() {
      this.appLoading = true;
      axios({
        url: "/user/all",
        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        data: {
          shop: localStorage.getItem("shopid"),
          category: this.$route.params.id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.users = response.data.data;
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    confirmBanUser(item) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to Ban this User.", {
          title: "Please Confirm",
          size: "md",
          buttonSize: "sm",
          okVariant: "danger",
          cancelVariant: "primary",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.banUser(item);
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    banUser(item) {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/ban",
        data: {
          id: item._id,
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.$notify({
              group: "appNotification",
              title: "User Banned Successfully",
              text: "",
              type: "success",
            });
            this.getData();
          } else {
            this.$notify({
              group: "appNotification",
              title: "Ban User Failed",
              text: "",
              type: "error",
            });
          }
        })
        .catch((e) => {
          console.log(e);
          this.ServerError = true;
        });
    },
    rowClicked(item) {
      this.$router.push("/Users/" + item._id);
    },
  },
};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
